// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Point } from '@shared/commons/Geometry';
import { Pen } from '@shared/commons/Graphics';
import { XYSeriesData } from '../Series/TerceraChartXYSeries';
import { TerceraChartStyledLineRenderer } from './TerceraChartStyledLineRenderer';
export class TerceraChartStyledVerticalLineRenderer extends TerceraChartStyledLineRenderer {
    constructor(chart) {
        super(chart);
        this.UseInAutoscale = false;
    }
    Draw(gr, window, windowsContainer, advParams) {
        if (!this.Visible) {
            return;
        }
        if (isNullOrUndefined(this.ColorStyleWidth)) {
            return;
        }
        if (isNullOrUndefined(this.Series) || this.Series.Count() === 0) {
            return;
        }
        const points = this.getPoints(window);
        if (points.length === 0) {
            return;
        }
        gr.save();
        const clientRect = window.ClientRectangle;
        const rect = new Path2D();
        rect.rect(clientRect.X, clientRect.Y, clientRect.Width, clientRect.Height);
        gr.clip(rect);
        const pen = new Pen(this.ColorStyleWidth.Color, this.ColorStyleWidth.Width, this.ColorStyleWidth.Style);
        for (let i = 0; i < points.length; i += 2) {
            gr.DrawLine(pen, points[i].X, points[i].Y, points[i + 1].X, points[i + 1].Y);
        }
        gr.restore();
    }
    getPoints(window) {
        const points = [];
        const clientRectangle = window.ClientRectangle;
        for (let i = 0; i < this.Series.Count(); i++) {
            const x = this.Series.GetValue(i, XYSeriesData.X_INDEX);
            const screenX = window.PointsConverter.GetScreenX(x);
            points.push(new Point(screenX, clientRectangle.Top()));
            points.push(new Point(screenX, clientRectangle.Bottom()));
        }
        return points;
    }
}
